var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllowLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8331 0L6.04603 23.7059H0.568359L6.25092 0H11.8331Z",
    fill: "#1DC2DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.525 0L14.7379 23.7059H9.26025L14.9428 0H20.525Z",
    fill: "#1DC2DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5767 24.0001C22.1532 24.0001 23.4312 22.722 23.4312 21.1455C23.4312 19.569 22.1532 18.291 20.5767 18.291C19.0002 18.291 17.7222 19.569 17.7222 21.1455C17.7222 22.722 19.0002 24.0001 20.5767 24.0001Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllowLogoIcon);
export default __webpack_public_path__ + "static/media/ellow-logo-icon.cfc60fa68457f1daca382d009717369a.svg";
export { ForwardRef as ReactComponent };